export const REFRESH_PRODUCTS = 'REFRESH_PRODUCTS';
